//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('equipmentGrp', {
//        templateUrl: 'views/components/views/equipmentGrp/equipmentGrp.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'equipmentGrpService', function ($stateParams, stateService, translateService, modalService, equipmentGrpService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let equipmentGrpId = $stateParams.equipmentgrp_id;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                equipmentGrpId: equipmentGrpId,
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await equipmentGrpService.getEdit({ equipmentgrp_id: equipmentGrpId }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                equipmentGrpService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
